import { useCallback, useState } from 'react';
import { ComposerTab } from './composerConstants.ts';

export interface AssistantComposerState {
	isAddOpen: boolean;
	activeTab: ComposerTab;
	selectTab: (tab: ComposerTab) => void;
	openAdd: () => void;
	closeAdd: () => void;
	toggleAdd: () => void;
}

/**
 * Owns the inline "Add" composer's open/closed state and the active entry tab.
 * Opening always resets to the Record tab so the composer starts on its most
 * common action rather than wherever it was left last time.
 */
export const useAssistantComposer = (initialTab: ComposerTab = ComposerTab.Record): AssistantComposerState => {
	const [isAddOpen, setIsAddOpen] = useState(false);
	const [activeTab, setActiveTab] = useState<ComposerTab>(initialTab);

	const openAdd = useCallback(() => {
		setActiveTab(initialTab);
		setIsAddOpen(true);
	}, [initialTab]);
	const closeAdd = useCallback(() => setIsAddOpen(false), []);
	const toggleAdd = useCallback(() => (isAddOpen ? closeAdd() : openAdd()), [closeAdd, isAddOpen, openAdd]);
	const selectTab = useCallback((tab: ComposerTab) => setActiveTab(tab), []);

	return { isAddOpen, activeTab, selectTab, openAdd, closeAdd, toggleAdd };
};
